export const ACCESS_TOKEN_KEY = 'accessToken';
export const ADMIN_INFO = 'Admin_Info';
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 1;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const FORMAT_TIME_DEFAULT = 'HH:mm';
export const FORMAT_DATE_DEFAULT = 'YYYY/MM/DD';
export const FORMAT_DATE_SUBMIT = 'YYYY-MM-DD';
export const SECRETARIAT_ADMIN = 'Secretariat_Admin';
export const TIME_ZONE = 'Asia/Tokyo';
export const MAX_INDENT_LEVEL = 30;

export const MEMBERSHIP_TYPE = [
  { value: 'Master_Trainer', label: 'マスタートレーナー' },
  {
    value: 'General_Instructor',
    label: '総合インストラクター',
  },
  { value: 'Instructor', label: 'インストラクター' },
];

export const STATUS = [
  { value: 'PUBLISHED', label: '公開中' },
  { value: 'DRAFT', label: '非公開' },
];

export const STATUSSELECTOR = [
  { value: 'PUBLISHED', label: '公開' },
  { value: 'DRAFT', label: '非公開' },
];

export const CLASSIFICATION_TYPE = [
  {
    value: 'NEW',
    label: '新規受講',
  },
  {
    value: 'RETAKE',
    label: '再受講',
  },
];

export const PAYMENT_STATUS = [
  {
    value: 'WAITING_FOR_PAYMENT',
    label: '支払い待ち',
  },
  {
    value: 'WAITING_FOR_REGISTRATION',
    label: 'キャンセル待ち',
  },
  {
    value: 'REGISTERED',
    label: '登録済み',
  },
  {
    value: 'ADMIN_CANCELED',
    label: 'キャンセル',
  },
];

export const prefectures = [
  { id: 1, area: '北海道・東北エリア', prefecture: '北海道' },
  { id: 2, area: '北海道・東北エリア', prefecture: '青森県' },
  { id: 3, area: '北海道・東北エリア', prefecture: '岩手県' },
  { id: 4, area: '北海道・東北エリア', prefecture: '宮城県' },
  { id: 5, area: '北海道・東北エリア', prefecture: '秋田県' },
  { id: 6, area: '北海道・東北エリア', prefecture: '山形県' },
  { id: 7, area: '北海道・東北エリア', prefecture: '福島県' },

  { id: 8, area: '関東エリア', prefecture: '茨城県' },
  { id: 9, area: '関東エリア', prefecture: '栃木県' },
  { id: 10, area: '関東エリア', prefecture: '群馬県' },
  { id: 11, area: '関東エリア', prefecture: '埼玉県' },
  { id: 12, area: '関東エリア', prefecture: '千葉県' },
  { id: 13, area: '関東エリア', prefecture: '東京都' },
  { id: 14, area: '関東エリア', prefecture: '神奈川県' },

  { id: 15, area: '北信越・中部エリア', prefecture: '新潟県' },
  { id: 16, area: '北信越・中部エリア', prefecture: '富山県' },
  { id: 17, area: '北信越・中部エリア', prefecture: '石川県' },
  { id: 18, area: '北信越・中部エリア', prefecture: '福井県' },
  { id: 19, area: '北信越・中部エリア', prefecture: '山梨県' },
  { id: 20, area: '北信越・中部エリア', prefecture: '長野県' },
  { id: 21, area: '北信越・中部エリア', prefecture: '岐阜県' },
  { id: 22, area: '北信越・中部エリア', prefecture: '静岡県' },
  { id: 23, area: '北信越・中部エリア', prefecture: '愛知県' },
  { id: 24, area: '北信越・中部エリア', prefecture: '三重県' },

  { id: 25, area: '近畿エリア', prefecture: '滋賀県' },
  { id: 26, area: '近畿エリア', prefecture: '京都府' },
  { id: 27, area: '近畿エリア', prefecture: '大阪府' },
  { id: 28, area: '近畿エリア', prefecture: '兵庫県' },
  { id: 29, area: '近畿エリア', prefecture: '奈良県' },
  { id: 30, area: '近畿エリア', prefecture: '和歌山県' },

  { id: 31, area: '中国・四国エリア', prefecture: '鳥取県' },
  { id: 32, area: '中国・四国エリア', prefecture: '島根県' },
  { id: 33, area: '中国・四国エリア', prefecture: '岡山県' },
  { id: 34, area: '中国・四国エリア', prefecture: '広島県' },
  { id: 35, area: '中国・四国エリア', prefecture: '山口県' },
  { id: 36, area: '中国・四国エリア', prefecture: '徳島県' },
  { id: 37, area: '中国・四国エリア', prefecture: '香川県' },
  { id: 38, area: '中国・四国エリア', prefecture: '愛媛県' },
  { id: 39, area: '中国・四国エリア', prefecture: '高知県' },

  { id: 40, area: '九州・沖縄エリア', prefecture: '福岡県' },
  { id: 41, area: '九州・沖縄エリア', prefecture: '佐賀県' },
  { id: 42, area: '九州・沖縄エリア', prefecture: '長崎県' },
  { id: 43, area: '九州・沖縄エリア', prefecture: '熊本県' },
  { id: 44, area: '九州・沖縄エリア', prefecture: '大分県' },
  { id: 45, area: '九州・沖縄エリア', prefecture: '宮崎県' },
  { id: 46, area: '九州・沖縄エリア', prefecture: '鹿児島県' },
  { id: 47, area: '九州・沖縄エリア', prefecture: '沖縄県' },

  { id: 48, area: '', prefecture: '海外' },
];

export const getImagePath = (url) => {
  if (!url) return '';
  if (url.startsWith('/')) return url;
  try {
    return new URL(url).pathname;
  } catch {
    return url.replace(/^https?:\/\/[^/]+/, '');
  }
};

export const courses = [
  {
    courseId: '01',
    courseName: 'マットI＆IIインストラクター養成コース',
    options: [
      {
        category: '再受講パターン①',
        duration: '1日間／4日間',
        tuition: '10,000円',
        ceu: 2,
        textbook: '',
      },
      {
        category: '再受講パターン②',
        duration: '1日間／2日間',
        tuition: '5,000円',
        ceu: 1,
        textbook: '',
      },
    ],
  },
  {
    courseId: '02',
    courseName: 'プロップスインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '135,269円',
        ceu: 6,
        textbook: '4043円',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '10,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '03',
    courseName: 'バレルインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '1日間',
        tuition: '83,790円',
        ceu: 6,
        textbook: '4043円',
      },
      {
        category: '再受講',
        duration: '1日間／1日間',
        tuition: '10,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '04',
    courseName: 'チェアインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '168,840円',
        ceu: 6,
        textbook: '4043円',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '13,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '05',
    courseName: 'リフォーマーIインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '231,000円',
        ceu: 6,
        textbook: '4043円',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '15,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '06',
    courseName: 'リフォーマーIIインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '231,000円',
        ceu: 6,
        textbook: '4043円',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '15,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '07',
    courseName: 'リフォーマーIIIインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '231,000円',
        ceu: 6,
        textbook: '4043円',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '15,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '08',
    courseName: 'タワーインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '231,000円',
        ceu: 6,
        textbook: '4043円',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '15,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '09',
    courseName: 'コアアラインIインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '275,000円',
        ceu: 6,
        textbook: '',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '15,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '10',
    courseName: 'コアアラインIIインストラクター養成コース',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '275,000円',
        ceu: 6,
        textbook: '',
      },
      {
        category: '再受講',
        duration: '1日間／2日間',
        tuition: '15,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
  {
    courseId: '11',
    courseName: 'ユアボックス®プログラム',
    options: [
      {
        category: '新規',
        duration: '2日間',
        tuition: '113,190円',
        ceu: 6,
        textbook: '',
      },
      {
        category: '再受講',
        duration: '1日間',
        tuition: '10,000円',
        ceu: 2,
        textbook: '',
      },
      {
        category: '新規',
        duration: '2日間',
        tuition: '153,000円',
        ceu: 6,
        textbook: '',
      },
    ],
  },
  {
    courseId: '12',
    courseName: 'インテグレーテッドトレーニングコース',
    options: [
      {
        category: '再受講1日目',
        duration: '1日間／2日間',
        tuition: '12,500円',
        ceu: 1.5,
        textbook: '',
      },
      {
        category: '再受講2日目',
        duration: '2日間／2日間',
        tuition: '15,000円',
        ceu: 2,
        textbook: '',
      },
    ],
  },
];

export const formatDateSlashToDash = (dateString) => {
  if (!dateString) return '';
  return dateString.replace(/\//g, '-');
};

export const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const numStr = value.toString().replace(/[^0-9.-]/g, '');
  const parts = numStr.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const STATUS_OPTIONS = [
  { value: 'ALL', label: '全て' },
  { value: 'PAYMENT_COMPLETED', label: '支払い済み' },
  { value: 'AMOUNT_DISCREPANCY', label: '金額相違あり' },
  { value: 'WAITING_FOR_PAYMENT', label: '支払い待ち' },
  { value: 'WAITING_FOR_REGISTRATION', label: '最小催行達成待ち' },
  { value: 'CANCELLATION_WAITING_LIST', label: 'キャンセル待ち' },
  { value: 'ADMIN_CANCELED', label: 'キャンセル' },
];

export const typeCEUs = [
  {
    value: 'A1',
    label: 'A.PHI主催セミナー',
  },
  {
    value: 'A2',
    label: 'A.養成コース名（新規）',
  },
  {
    value: 'B1',
    label: 'B.養成コース名（再受講）',
  },
  {
    value: 'B2',
    label: 'B.ブラッシュアップセミナー ',
  },
  {
    value: 'B3',
    label: 'B.パーソナルセッション',
  },
  {
    value: 'B4',
    label: 'B.ポケ模型®',
  },
  {
    value: 'C1',
    label: 'C.出版、執筆活動',
  },
  {
    value: 'C2',
    label: 'C.学会活動',
  },
  {
    value: 'C3',
    label: 'C.講師活動',
  },
  {
    value: 'D1',
    label: 'D.米国PHIオンラインセミナー',
  },
  {
    value: 'D2',
    label: 'D.米国PHI主催セミナー',
  },
  {
    value: 'E1',
    label: 'E.パーソナルスタディ',
  },
];
